/**
 * The page facts the public list endpoints send today, flat beside `data`:
 * `{ data, page, limit, total, ... }`.
 *
 * The admin lists group the same facts under `pagination` (see `Paginated` in
 * `types/api`). If the public ones move to that shape, this file and the types
 * that use it are the only things to change.
 */
export interface PageInfo {
  page: number;
  limit: number;
  total: number;
}

/**
 * The next page to ask for, or `undefined` once everything has been loaded —
 * TanStack's `getNextPageParam` contract, so it can be passed straight in.
 * Worked out from `total` rather than from a short last page, so it never
 * spends a request to discover there is nothing left.
 */
export const nextPage = (last: PageInfo): number | undefined =>
  last.page * last.limit < last.total ? last.page + 1 : undefined;
